"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _reactIntl = require("react-intl");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// I know this is a tiny component, but the advantage of having a small
// stateless component like this is that the style and design stays in one place
// make it easy to share.
var styles = {
  "item": "check_list_item-module__item___FEclB",
  "icon": "check_list_item-module__icon___cPz8w",
  "checked": "check_list_item-module__checked___miBk8 check_list_item-module__icon___cPz8w",
  "unchecked": "check_list_item-module__unchecked___CfUa9 check_list_item-module__icon___cPz8w",
  "display": "check_list_item-module__display___SSDiz",
  "sub_display": "check_list_item-module__sub_display___D2LVl"
};
class CheckListItem extends _react.default.PureComponent {
  static propTypes = {
    checked: T.bool.isRequired,
    onClick: T.func.isRequired,
    val: T.string,
    msg: T.string,
    display: T.string,
    displayId: T.string,
    subDisplay: T.string,
    subDisplayId: T.string
  };
  static defaultProps = {
    checked: true
  };
  renderSubDisplaySpan(display) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: styles.sub_display
    }, display);
  }
  renderSubDisplay() {
    const {
      subDisplayId,
      subDisplay
    } = this.props;
    if (subDisplayId) {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: subDisplayId,
        children: msg => this.renderSubDisplaySpan(msg)
      });
    } else if (subDisplay) {
      return this.renderSubDisplaySpan(subDisplay);
    }
    return false;
  }
  renderLi(checked, display, onClick) {
    return /*#__PURE__*/_react.default.createElement("li", {
      className: styles.item,
      onClick: onClick
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: checked ? styles.checked : styles.unchecked
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.display
    }, display, this.renderSubDisplay()));
  }
  render() {
    const {
      checked,
      displayId,
      display,
      onClick,
      val
    } = this.props;
    if (displayId) {
      return /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: displayId,
        children: msg => this.renderLi(checked, msg, onClick)
      });
    } else {
      return this.renderLi(checked, display || val, onClick);
    }
  }
}
exports.default = CheckListItem;